import Vue from 'vue';
export default Vue.extend({
    props: {
        width: {
            type: [Number, String],
            default: null
        },
        widthSm: {
            type: [Number, String],
            default: null
        },
        widthMd: {
            type: [Number, String],
            default: null
        },
        widthLg: {
            type: [Number, String],
            default: null
        },
        widthXl: {
            type: [Number, String],
            default: null
        },
        widthXxl: {
            type: [Number, String],
            default: null
        },
        widthHd: {
            type: [Number, String],
            default: null
        },
        align: {
            type: String,
            default: null
        },
        equal: {
            type: Boolean,
            default: false
        },
        index: {
            type: [Number, String],
            default: null
        },
    },
    // @ts-ignore
    getClassMap: function (props) {
        return [
            props.width ? "col-".concat(props.width) :
                props.equal ? 'col' : 'col-12',
            props.widthSm ? "col-sm-".concat(props.widthSm) : null,
            props.widthMd ? "col-md-".concat(props.widthMd) : null,
            props.widthLg ? "col-lg-".concat(props.widthLg) : null,
            props.widthXl ? "col-xl-".concat(props.widthXl) : null,
            props.widthXxl ? "col-xxl-".concat(props.widthXxl) : null,
            props.widthHd ? "col-hd-".concat(props.widthHd) : null,
            props.align == 'right' ? 'ml-auto' : null,
            props.align == 'left' ? 'mr-auto' : null,
        ];
    }
});
